import { createSlice } from "@reduxjs/toolkit";

const initialState = { refundRequests: [] };

export const refundRequestSlice = createSlice({
  name: "refundRequest",
  initialState,
  reducers: {
    setRefundRequestList: (state = initialState, { payload }) => {
      return {
        ...state,
        refundRequests: payload,
      };
    },
  },
});
